export default __webpack_public_path__ + "static/media/9t.7e2d1306.jpg";